<div class="relative">

	<button
		class="relative flex flex-row gap-1 items-center justify-center text-peps-text-10 text-shadow-zinc-500 text-shadow-xs transition-colors duration-300 cursor-pointer bg-peps-gold px-2 py-2 rounded-full"
		(click)="toggle($event)"
	>
		@if (unreadCount > 0) {
			<span class="min-w-4 h-4 rounded-full font-dinpro-medium flex items-center justify-center absolute -top-1 -right-1 bg-peps-red p-1.5 py-2.5 text-xs z-20">
				{{ unreadCount > 9 ? '9+' : unreadCount }}
			</span>
		}

		<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" [class.bell-shake]="unreadCount > 0">
			<path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
		</svg>

		@for (p of particles; track p.id) {
			<img
				src="assets/emotes/pepite.png"
				alt=""
				class="pepite-particle"
				[style.--tx]="p.tx"
				[style.--ty]="p.ty"
				[style.--rot]="p.rot"
			/>
		}
	</button>

	@if (isOpen) {
		<div class="fixed inset-x-4 top-20 xl:absolute xl:inset-x-auto xl:top-full xl:right-0 xl:mt-2 w-auto xl:w-[28rem] bg-peps-dark-700 border border-peps-dark-500 z-50 overflow-hidden">

			<div class="h-px w-full bg-peps-gold"></div>

			<div class="flex items-center justify-between px-4 py-3 border-b border-peps-dark-500">
				<span class="text-xs uppercase font-dinpro-medium tracking-[0.3em] text-peps-dark-200">
					{{ 'component.notification-center.title' | translate }}
				</span>
				@if (unreadCount > 0) {
					<button
						(click)="markAllAsRead()"
						(keydown.enter)="markAllAsRead()"
						class="text-[10px] uppercase font-dinpro-medium text-peps-gold hover:text-peps-yellow tracking-widest transition-colors duration-200 cursor-pointer"
					>{{ 'component.notification-center.mark-all-read' | translate }}</button>
				}
			</div>

			<div class="max-h-80 xl:max-h-[32rem] overflow-y-auto custom-scrollbar">
				@if (notifications.length === 0) {
					<div class="flex flex-col items-center gap-4 px-4 py-10">
						<img src="assets/emotes/pepite.png" alt="" class="w-10 h-10 opacity-20">
						<span class="text-xs uppercase font-dinpro-medium tracking-[0.2em] text-peps-dark-200/30 text-center">
							{{ 'component.notification-center.empty' | translate }}
						</span>
					</div>
				} @else {
					@for (notif of notifications; track notif.id) {
						<div
							class="relative flex items-start gap-3 border-b border-peps-dark-500 last:border-0 transition-colors duration-200"
							[class.bg-peps-dark-600]="!notif.read"
						>
							@if (!notif.read) {
								<div class="absolute left-0 top-0 bottom-0 w-0.5 bg-peps-gold"></div>
							}

							<div class="shrink-0 mt-0.5 px-4 py-3">
								<img src="assets/emotes/pepite.png" alt="" class="w-5 h-5">
							</div>

							<div class="flex-1 flex flex-row justify-between min-w-0">
								<div class="flex flex-col py-3">
									<p class="text-sm font-notosans leading-snug text-peps-dark-200/80">{{ getNotificationKey(notif) | translate:notif.metadata }}</p>
									<div class="flex items-center justify-between gap-3 mt-1">
										<p class="text-[10px] uppercase font-dinpro-medium tracking-wider text-peps-dark-200/30">
											{{ notif.createdAt | date:'dd/MM/yyyy HH:mm' }}
										</p>
									</div>
								</div>

								@if (notificationLink(notif); as link) {
									<a
										[routerLink]="link"
										(click)="onView(notif)"
										class="p-3 shrink-0 inline-flex items-center gap-1 text-[10px] uppercase font-dinpro-medium tracking-widest text-peps-gold hover:text-peps-yellow transition-colors duration-200 cursor-pointer"
									>
										{{ 'component.notification-center.view' | translate }}
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3">
											<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
										</svg>
									</a>
								}
							</div>

						</div>
					}
				}
			</div>

		</div>
	}

</div>
